// src/hooks/useSettings.js
import { createContext, useContext, useEffect, useState } from 'react';
import { getSettings, saveSettings as save } from '../lib/dataService';
import { useAuth } from './useAuth';

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const { user } = useAuth();
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    if (!user) return;
    getSettings().then(setSettings);
  }, [user]);

  const updateSettings = async (newSettings) => {
    setSettings(newSettings);
    await save(newSettings);
  };

  return (
    <SettingsContext.Provider value={{ settings, updateSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
